/*
 * Module for the Benefit Payroll Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrollregistercriteria",

    ["controls/data/grid", "common/select-helper"],

    function (gridModule, selectHelper) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls, compositeMonthYearColumnID) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            includeManualCheckBox.change(filterCheckBoxChanged);

            // Refresh the grid based on checkbox selection
            function filterCheckBoxChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            var payrollProcessingMonthYearHidden = $.js(jsSelectors.payrollProcessingMonthYearHidden);

            // Populate the hidden field with the Payroll Period of the selected row
            lrsGridApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {
                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    payrollProcessingMonthYearHidden.val(compositeMonthYear);
                } else {
                    payrollProcessingMonthYearHidden.val('');
                }
            });

            var payrollSummaryOnlyCheckBox = $.js(jsSelectors.payrollSummaryOnlyCheckBox);
            var sortBySelectHelper = selectHelper.getHelper($.js(jsSelectors.sortBySelect));

            // Disable and clear the Sort By if selected
            payrollSummaryOnlyCheckBox.change(function () {
                if (this.checked) {
                    sortBySelectHelper.clearOptions();
                } else {
                    sortBySelectHelper.loadOptionsFrom(ajaxUrls.populateSortUrl);
                }

                sortBySelectHelper.setDisabled(this.checked);
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);